import { useEffect, useState } from "react";

const DEFAULT_DELAY_MS = 450;

/**
 * Brief loading state for BaaS console pages.
 * Re-triggers when dependencyKey changes (e.g. selected instance id).
 */
export const useBaasPageLoading = (dependencyKey = null, delayMs = DEFAULT_DELAY_MS) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), delayMs);
    return () => clearTimeout(timer);
  }, [dependencyKey, delayMs]);

  return isLoading;
};
